import { useEffect, useRef, useState } from "react";
import { useCoreValues } from "@/hooks/useSiteContent";
import ContentStatus from "@/components/feature/ContentStatus";

export default function CoreValuesSection() {
  const { data: coreValues, loading, error, reload } = useCoreValues();
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 },
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div
          className={`text-center mb-10 md:mb-14 transition-all duration-700 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <span className="inline-flex items-center gap-1.5 px-4 py-1.5 bg-accent-100 text-accent-700 text-xs md:text-sm font-label font-medium rounded-full mb-4">
            <i className="ri-shining-fill" />
            Giá trị cốt lõi
          </span>
          <h2 className="font-display text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Điều chúng tôi luôn theo đuổi
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto font-body">
            Năm giá trị xuyên suốt mọi liệu trình và trải nghiệm khách hàng tại Xanh Wellness.
          </p>
        </div>

        <ContentStatus loading={loading} error={error} onRetry={reload}>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {coreValues.map((value, index) => (
              <div
                key={value.id}
                className={`bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6 hover:border-primary-300 transition-all duration-500 ${
                  visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
                }`}
                style={{ transitionDelay: visible ? `${index * 100}ms` : "0ms" }}
              >
                <div className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4">
                  <i className={`${value.icon} text-xl md:text-2xl`} />
                </div>
                <h3 className="font-display text-base md:text-lg font-semibold text-foreground-950 mb-2">
                  {value.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed font-body">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </ContentStatus>
      </div>
    </section>
  );
}